import React from 'react';
import {
  Button, Row, Col, Icon, Input
  , Dropdown, Menu, Table, Popconfirm
  , Radio
} from 'antd';
import { inject, observer } from 'mobx-react';
import AppDatasBody from '../util/AppDatasBody';
import AppAddModal from '../util/AppAddModal';
import AppApplyModal from '../util/AppApplyModal';
import Navigation from '../public/navigation';
import { toJS } from 'mobx';

const RadioGroup = Radio.Group;

@inject('homeStore')
@inject('collectStore')
@observer
class App extends React.Component {

  componentDidMount() {
    const { collectStore, location } = this.props;
    collectStore.callMyAppData(location.query);
    collectStore.getRoutes(location.query);
    collectStore.selectedRows = [];
    collectStore.selected = false;
  }

  componentWillReceiveProps(nextProps) {
  }

  //申请应用点击
  handleApplyClick() {
    const { collectStore, homeStore } = this.props;
    let { selectedRows } = collectStore;
    let sw_id = [], s_id = [], appInfo = [];
    selectedRows.forEach(item => {
      sw_id.push(item.sw_id);
      s_id.push(item.s_id);
      appInfo.push({ appId: item.s_number, appName: item.s_name });
    });
    let param = { sw_id: sw_id.toString(), s_id: s_id.toString() };
    homeStore.callApply(param, appInfo);
  }

  //添加下拉框点击
  handleMenuClick(e) {
    const { collectStore } = this.props;
    if (e.key !== "") {
      if (e.key === "1") {
        collectStore.callToAddAPP("??todo:所选应用id", e.key)
      } else {
        collectStore.callAddWhereData(e.key)
        collectStore.addModal = { ...collectStore.addModal, addWhere: e.key, visible: true };
      }
    }
  }

  //添加应用确认
  handleOk(key, name, type) {
    const { collectStore } = this.props;
    type ? collectStore.projSearchData = { ...collectStore.projSearchData, projName: name }
      : collectStore.schemeSearchData = { ...collectStore.schemeSearchData, schemeName: name };
    collectStore.callToAddAPP("??todo:所选应用id", key)
    collectStore.addModal = { ...collectStore.addModal, visible: false };
  }

  setWhere(v) {
    const { collectStore } = this.props;
    collectStore.searchData = { ...collectStore.searchData, wherekey: v }
    collectStore.callMyAppData(collectStore.leftMenu);
  }

  isSelectedAll() {
    const { collectStore } = this.props;
    const { appDatas, selectedRows } = collectStore;
    let currentDatas = toJS(appDatas);
    let intersection = selectedRows.filter(v => {
      let temp = currentDatas.filter(o => {
        return o.sw_id === v.sw_id;
      });
      return temp.length !== 0;
    })
    collectStore.selected = intersection.length === currentDatas.length;
  }

  onSearch() {
    const { collectStore } = this.props;
    const { searchValue, params } = collectStore;
    params.searchValue = searchValue.application;
    params.kind = searchValue.category;
    collectStore.params = params;
    collectStore.callMyAppData(params);
  }

  remove() {
    const { collectStore, location } = this.props;
    const { selectedRows } = collectStore;
    let sw_ids = [];
    selectedRows && selectedRows.forEach(item => {
      sw_ids.push(item.sw_id);
    });
    collectStore.callRemove({ s_ids: sw_ids.toString() }, location.query);
  }


  render() {
    const server = window.server;
    const { homeStore: { setType }, collectStore, location, homeStore } = this.props;
    let {
      routes, routing, appDatas, setPage, selectedRows
      , searchValue, params, selected, callMyAppData, loading
    } = collectStore;
    const columns = [
      {
        key: '1',
        title: '表单名称',
        dataIndex: 'name',
        render(text, record, index) {
          return (
            <div>
              <div style={{ display: 'inline-block' }}>
                <img className='list-table-img'
                  src={server + record.s_pictureNati}
                  alt='' />
              </div>
              <div className='list-table-record' style={{ display: 'inline-block' }}>
                <div style={{ fontWeight: 600, cursor: 'pointer' }}
                  onClick={() => {
                    window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.s_wfid);
                  }}>{record.s_name}</div>
                <div className='list-table-record-sub'>
                  <Icon type="eye-o" />
                  <span>{record.s_count}次</span>
                  <Icon type="download" />
                  <span style={{ color: '#ffab65' }}>{record.s_count}</span>次
                </div>
              </div>
            </div>
          )
        }
      },
      {
        key: '2',
        title: '操作',
        width: 200,
        render(text, record, index) {
          return (
            <div>
              {
                record && record.hpid
                  ? <span className='list-table-btn'
                    onClick={() => {
                      window.open("http://203.110.166.54:8085/homepage/Homepage.jsp?subCompanyId=25&showbtn=0&isfromportal=1&hpid=" + record.hpid)
                    }}>预览</span>
                  : <span className='list-table-btn'
                    onClick={() => {
                      window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.s_wfid);
                    }}>预览</span>
              }
              <span className='list-table-btn'
                onClick={() => {
                  let param = { sw_id: record.sw_id, s_id: record.s_id };
                  let appInfo = [{ appId: record.s_number, appName: record.s_name }];
                  homeStore.callApply(param, appInfo);
                }}
              >申请</span>
              <Popconfirm title="确定要移除吗？"
                okText="确定"
                cancelText="取消"
                onConfirm={() => {
                  let param = { s_ids: record.sw_id };
                  collectStore.callRemove(param, location.query);
                }}>
                <span className='list-table-btn'>移除</span>
              </Popconfirm>
              {/*<span className='list-table-btn-line'>|</span>*/}
              {/*<Dropdown overlay={menuTable}>*/}
              {/*<a>*/}
              {/*添加至 <Icon type="down"/>*/}
              {/*</a>*/}
              {/*</Dropdown>*/}
            </div>
          )
        }
      }
    ];
    return (
      <div className='collect'>
        <AppDatasBody location={location}>
          <Navigation datas={toJS(routes)} onClick={(obj) => {
            if (obj.path !== '/') {
              routing.push({
                pathname: obj.path,
                query: {
                  id: location.query.id,
                  radioType: location.query.radioType,
                  radioItem: location.query.radioItem,
                  radioSubItem: location.query.radioSubItem,
                }
              });
            } else {
              routing.push('/');
              setType('all', '全部应用');
            }
          }} />
          <Row className="cs-search-mylist collect-mylist">
            <Col span={17}>
              <Row>
                <Col span={4} style={{ paddingTop: 5 }}> <label>表单名称：</label></Col>
                <Col span={8}> <Input placeholder='请输入表单名称'
                  value={searchValue.application}
                  onChange={(e) => {
                    collectStore.searchValue = { ...searchValue, application: e.target.value }
                  }} /></Col>
                <Col span={12} style={{ marginTop: 5, paddingLeft: 20 }}>
                  {
                    location.query.id === 'all' && (
                      <Row>
                        <Col span={4}> <label>类别：</label></Col>
                        <Col span={20}>
                          <RadioGroup
                            value={searchValue.category}
                            onChange={(e) => {
                              collectStore.searchValue = { ...searchValue, category: e.target.value };
                            }}>
                            <Radio value='-1'>全部</Radio>
                            <Radio value='1'>流程</Radio>
                            <Radio value='2'>门户</Radio>
                          </RadioGroup>
                        </Col>
                      </Row>
                    )
                  }
                </Col>
              </Row>
            </Col>
            <Col span={7}>
              <Col span={16} offset={8}>
                <Button type="primary"
                  style={{ marginRight: 10 }}
                  onClick={this.onSearch.bind(this)}>搜索</Button>
                <Button type="ghost"
                  onClick={() => {
                    collectStore.searchValue = { category: '0', application: '' };
                    this.onSearch();
                  }}>重置</Button>
              </Col>
            </Col>
          </Row>
          <div style={{ margin: '10px 0' }}>
            <Button style={{ marginRight: 10 }}
              disabled={selectedRows.length === 0}
              onClick={this.handleApplyClick.bind(this)}>批量申请</Button>
            <Button style={{ marginRight: 10 }}
              disabled={selectedRows.length === 0}
              onClick={this.remove.bind(this)}
            >批量移除</Button>
            {/*<Dropdown overlay={menu}>*/}
            {/*<Button style={{marginRight: 10}}>*/}
            {/*批量添加至 <Icon type="down"/>*/}
            {/*</Button>*/}
            {/*</Dropdown>*/}
          </div>
          <Table columns={toJS(columns)}
            dataSource={toJS(appDatas)}
            className={`list-table collect-list-table ${selected && 'list-table2'}`}
            loading={loading}
            pagination={
              {
                showSizeChanger: true,
                showQuickJumper: true,
                pageSize: params.pageSize,
                total: params.total,
                onChange: (current, pageSize) => {
                  setPage(current, pageSize);
                  callMyAppData(collectStore.params);
                  this.isSelectedAll();
                },
                onShowSizeChange: (current, size) => {
                  collectStore.params.pageSize = size;
                  collectStore.params.current = 1;
                  collectStore.callMyAppData();
                }
              }
            }
            locale={{
              emptyText:
                <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center' }}>
                  <Icon type="frown-o" />
                  <span style={{ marginLeft: 4 }}>暂无数据</span>
                </div>
            }}
            rowSelection={
              {
                type: 'checkbox',
                onChange: (selectedRowKeys, selectedRows) => {
                  collectStore.selectedRows = selectedRows;
                  this.isSelectedAll();
                },
                onSelectAll: selected => {
                  collectStore.selected = selected;
                }
              }
            } />
          <AppAddModal addModal={collectStore.addModal}
            location={location}
            handleCloseModal={() => {
              collectStore.addModal = { ...collectStore.addModal, visible: false }
            }}
            handleOk={this.handleOk.bind(this)}
            onSearch={(params) => {
              collectStore.callAddWhereData(collectStore.addModal.addWhere, params)
            }} />

          <AppApplyModal applyModal={homeStore.applyModal}
            applyApps={homeStore.applyApps}
            handleCloseModal={() => {
              homeStore.applyModal = { ...homeStore.applyModal, visible: false }
            }} />
        </AppDatasBody>
      </div>
    )
  }
}

export default App

// 添加至按钮
// const menu = (
//   <Menu onClick={this.handleMenuClick.bind(this)}>
//     <Menu.Item key="2" disabled={selectedRows.length === 0}>我的项目</Menu.Item>
//     <Menu.Item key="3" disabled={selectedRows.length === 0}>我的方案</Menu.Item>
//   </Menu>
// );
// const menuTable = (
//   <Menu onClick={this.handleMenuClick.bind(this)}>
//     <Menu.Item key="2">我的项目</Menu.Item>
//     <Menu.Item key="3">我的方案</Menu.Item>
//   </Menu>
// );


// WEBPACK FOOTER //
// ./src/components/collect/Collect.js